import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { snackbarError } from 'actions/snackbarMessage';
import axiosClient from '@lib/utils/axiosClient';
import { makeResourceKeys } from 'requests/resources/makeResources/makeResourcesKeys';

const BASE_URL = 'v2/customWebStyles';

export const key = makeResourceKeys('custom-web-styles');

const publishFn = (id: string) => axiosClient.put(`${BASE_URL}/${id}`, { published: true });

// Hooks

export const usePublishCustomWebStyles = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation((id: string) => publishFn(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(key.$all);
    },
    onError: () => {
      dispatch(snackbarError('Something went wrong'));
    },
  });
};
